import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class PersonalProtectiveEquipmentProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'personalProtective'}
            title={'PROCEDURE P22.0 PERSONAL PROTECTIVE EQUIPMENT'}
            exportTitle={'<h2>Procedure P22.0 Personal Protective Equipment</h2>'}
            exportFileName={'personal_protective.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (PersonalProtectiveEquipmentProcedure);